<template>
    <div class="dropdown-container" :class="classes">
        <div class="dropdown" v-click-outside="clickOutsideConfig">
            <div class="current" @click="toggle">
                <div class="label">{{ data[modelValue] }}</div>
                <div class="icon">
                    <svg class="icon-arrow" xmlns="http://www.w3.org/2000/svg" width="16.14" height="9.51" viewBox="0 0 16.14 9.51">
                        <path d="M7.968,18.253a1.432,1.432,0,0,1-1.022-.429,1.5,1.5,0,0,1-.01-2.1l5.474-5.535L6.944,4.652a1.5,1.5,0,0,1,0-2.109,1.433,1.433,0,0,1,2.049,0L15.65,9.274a1.3,1.3,0,0,1,0,1.817L8.992,17.822A1.432,1.432,0,0,1,7.968,18.253Z" transform="translate(18.253 -6.511) rotate(90)" fill="#435152"/>
                    </svg>
                    <svg class="icon-triangle" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g transform="translate(-1577 4005)">
                        <path d="M8.71,11.71,11.3,14.3a1,1,0,0,0,1.41,0l2.59-2.59A1,1,0,0,0,14.59,10H9.41A1,1,0,0,0,8.71,11.71Z" transform="translate(1577 -4005)" fill="#435152"/>
                      </g>
                    </svg>
                </div>
            </div>
            <div class="items">
                <div class="item" v-for="(label,key) in data" :key="`drop-i-${key}`" 
                :class="{selected: key === modelValue}"
                @click="()=>{select(key)}">
                    <div class="divider"></div>
                    <div class="content">
                        <div class="label">{{ label }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
export default {
    name: 'DropDown',
    emits: ['update:modelValue'],
    props: {
        modelValue: { required: true },
        data: { type: Object, required: true },
        langPicker: Boolean,
        dark: Boolean,
    },
    data () { return {
        open: false,
        clickOutsideConfig: {
            handler: this.clickOutside,
            capture: true
        }
    }},
    directives: {
      clickOutside: vClickOutside.directive
    },
    computed: {
        classes(){
            return {
                open: this.open,
                closed: !this.open,
                [`preset-${this.preset}`]: true // preset-language-picker
            }
        },
        preset(){
            if(this.langPicker){
                return 'language-picker'
            }
            if(this.dark){
                return 'regular-dark'
            }
            return 'regular'
        }
    },
    methods: {
        close(){
            this.open = false
        },
        toggle(){
            this.open = !this.open
        },
        select(value){
            this.$emit('update:modelValue', value)
            this.close()
        },
        clickOutside(e){
            if(this.open){
                e.stopPropagation()
                this.close()
            }
        }
    }
}
</script>

<style lang="css" scoped>
.dropdown-container {
    display: block;
    text-align: left;
    height: 40px;
    user-select: none;
  z-index: 5;
}
.dropdown-container.preset-language-picker {
    height: 48px;

}

.dropdown {
    border-radius: 20px;
    position: relative;
    display: flex;
    flex-flow: column;
    transition: all 0.15s ease;
    border: 1px solid #435152;
}
.dropdown-container.preset-regular-dark .dropdown {
    border-color: rgba(247,247,249,0.25);
}
.dropdown-container.preset-language-picker .dropdown {
    border-color: #7E9495;
    border-radius: 8px;
    overflow: hidden;
}

.label {
    white-space: nowrap;
}

.current {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 11px 7px 15px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.1s ease;
}
.current:active {
    background-color: rgba(0,0,0,0.015);
}
.dropdown-container.preset-regular-dark.closed .current {
    color: #F7F9F9;
}
.preset-language-picker .current {
    font-weight: normal;
    padding: 13px 18px 13px 15px;
}

.current .label {
    font-size: 16px;
    line-height: 20px;
    margin-right: 12px;
}

.items {
    display: none;
    flex-flow: column;
    padding-top: 8px;
    padding-bottom: 9px;
}

.item .content {
    margin-left: -1px;
    margin-right: -1px;
    padding-left: 18px;
    padding-right: 16px;
    transition: all 0.17s ease-in-out;
    cursor: pointer;
}
.item .content .label {
    font-size: 16px;
    line-height: 40px;
    transition: all 0.15s ease;
}

.item:hover .content {
    background-color: #F7F7F7;
}
.item:hover .content .label {
    color: #0f0f0f;
}
.item .divider {
    margin-left: 17px;
    margin-right: 15px;
    height: 1px;
    border-bottom: 1px solid #D7DDDD;
}

.selected {
    pointer-events: none;
}
.selected .label {
    opacity: 0.2;
}


.icon,
.icon svg,
.icon path {
    transition: all 0.17s ease-in-out;
}

.icon svg {
    display: none;
}
.icon .icon-arrow {
    position: relative;
    top: 0.5px;
}
.preset-language-picker .icon .icon-arrow {
    display: block;
}
.preset-regular .icon .icon-triangle,
.preset-regular-dark .icon .icon-triangle {
    display: block;
}
.preset-regular-dark .icon .icon-triangle path {
    fill: #F7F9F9
}

.dropdown-container.open .dropdown {
    border-color: transparent;
    box-shadow: 0 3px 6px rgba(0,0,0,.15);
    background-color: white;

    /*background-color: rgba(255,255,255,0.88);*/
    /*backdrop-filter: saturate(1.8) blur(16px);*/
    border-radius: 8px;
}  
.dropdown-container.open .dropdown .icon path { 
    fill: #E77423;
}
.dropdown-container.open .dropdown .icon svg {
    transform: rotate(180deg);
}
.dropdown-container.open .dropdown .items {
    display: flex;
}

.dropdown-container.closed .dropdown:hover {
    border-color: #D7DDDD;
}

</style>
